import { render } from "./MergeCartModal.vue?vue&type=template&id=50c23087"
import script from "./MergeCartModal.vue?vue&type=script&lang=js"
export * from "./MergeCartModal.vue?vue&type=script&lang=js"

import "./MergeCartModal.vue?vue&type=style&index=0&id=50c23087&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__